import type React from 'react';

import type { WithDataTestid } from '@vlabs/uikit/types';
import classNames from 'classnames';

import st from './TypeIcon.module.sass';

type TypeIconVariant = 'primary' | 'secondary' | 'pink';

interface TypeIconProps extends WithDataTestid {
  children: React.ReactNode;
  variant?: TypeIconVariant;
  className?: string;
}

function TypeIcon({
  children,
  variant = 'primary',
  className = undefined,
  'data-testid': dataTestId = undefined,
}: TypeIconProps): React.JSX.Element {
  return (
    <span
      className={classNames(st.Root, st[`Root_${variant}`], className)}
      data-testid={dataTestId}
    >
      {children}
    </span>
  );
}

export { TypeIcon };
export type { TypeIconProps, TypeIconVariant };
